import { FC } from 'react';
import { useSendFormsStore } from '../../../providers';
import { EmailDeliveryMode } from './email-mode/email-mode.component';
import { KioskDeliveryMode } from './kiosk-mode/kiosk-message-mode.component';

const SelectedDeliveryMode: FC = () => {
  const { selectedDeliveryMethod } = useSendFormsStore(['selectedDeliveryMethod']);

  if (selectedDeliveryMethod === 'email') {
    return <EmailDeliveryMode />;
  }

  if (selectedDeliveryMethod === 'kiosk') {
    return <KioskDeliveryMode />;
  }

  return null;
};

export default SelectedDeliveryMode;
